import { Injectable } from '@angular/core';

@Injectable()
export class LanguageService {

  public icon =
    {
      TRUCKR: ""
    }

  public login =
    {
      or: "OR", email: "enter email or phone number", pwd: "enter password", login: "Login",
      forgotPwd: "Forgot Password", notRegd: "Not registered", createAcc: "Create an account", Note: "",
      incorrectPwd: "", Please_enter_at_lease_3_characters: ""
    }

  public create_account =
    {
      individual: "Individual", name: "name", email: "email address", pwd: "password", refCode: "referral code (optional)",
      agree: "I agree to the", tc: "Terms and Conditions", and: "and", policy: "Privacy Policy",
      createAcc: "Create an account", alreadyRegd: "Already registered", signin: "Sign In",
      business: "Business", companyName: "company name", companyAdd: "company Address",
      emailValid: "Please enter a valid e-mail or phone",
      numberValid: "Please enter valid number", checking: "Checking", refCodeValid: "Invalid referral code"
    }

  public Forgot_Password =
    {
      resetPwd: "Reset Password", email: "enter email or phone number", send: "Submit",
    }

  public dispatcherhome =
    {
      bookNow: "Book", bookLater: "Book Later", To: "To", back: "Back", error: "trigger_error", ongoing: "Ongoing", req: "Requested",
      past: "Past", noBookings: "No Bookings Available", jobId: "Trip Id", bookingReq: "Booking Requested", pickup: "PICKUP", details: "DETAILS",
      drop: "DROP", cash: "CASH", loadMore: "Load More", srynobookings: "Sorry, no more bookings", tasks: "Tasks", notifications: "Notifications",
      noNotifications: "No notifications available at this moment", myAcc: "My Account", logout: "Logout", jobDetails: "Ride Details",
      bookingId: "Booking ID", driverId: "Driver ID", filters: "Filters", default: "Default", silverMode: "Silver Mode", nightMode: "Show Night Mode",
      retroMode: "Show Retro Mode", hideFeatures: "Hide Features", copyright: "Copyright", linkName: "Appscrip.com", year: "2018", uberfortrucklink: "www.uberforall.com",
      privacy: "Privacy", terms: "Terms", loggedout: "LOGGED OUT", loginToCont: "You have been logged in from another device. Please login again to continue",
      login: "LOG IN", noservicemsg: "We are not opeartional in your selected area at this moment , please select a different address or contact support at dreamer@appscrip.com.",
      ok: "OK", noservicemsg1: "selected vehicle type does not operate long hauls, please select a different vehicle type or change the drop address.",
      createTask: "Create Tasks via CSV", download: "Download Sample File", getZones: "Get all Zones", close: "Close",
      all: "All", establish: "Establishments", add: "Addresses", geocode: "Geocodes", loadmore: "Load More", nobookings: "Sorry no more bookings",
      ddd: "ddd", to: "To", card: "Card", credit: "Credit", dd: "dd", online: "Online", offline: "Offline", name: "Name", email: "Email",
      phone: "Phone", status: "Status", vehicleDetails: "Vehicle details", vehicleType: "Vehicle Model", plateNum: "Vehicle Plate No",
      activity: "Activity Timeline", bookingAt: "Booking created at", driveracc: "Driver accepted time", driveronway: "Driver on the way",
      driverArrAt: "Driver arrived at", driverStarted: "Driver loaded and started at", driverEnroute: "Loaded and driver enroute to drop at",
      driverReached: "Driver reached destination at", bookingComplete: "Booking Completed at", pathHistory: "Path History", docs: "Driver documents",
      invoice: "Invoice", notAvail: "Not Available", sign: "Signature", validLoc: "Please enter valid location", validCardNum: "Please enter valid card number",
      validExpiry: "Please enter valid expiry details", validAdd: "please enter valid address", payment: "payment", mychannel: "mychannel"
    }

  public job_details =
    {
      pickupDetails: "Pickup Details", dropDetails: "Drop Details", pickupAdd: "Pickup Address", dropAdd: "Drop Address",
      goodstype: "Goodstype", groceries: "", qty: "Quantity", loose: "Loose", amt: "Amount", helpers: "No of helpers requested",
      driverDetails: "Driver Details", desc: "Ride Description", refImage: "Reference Image", cancelBooking: "Cancel Booking", vehType: "Vehicle Type", vehNum: "Vehicle Plate No"
    }

  public cancel_booking =
    {
      canBooking: "Cancel Booking", reason: "Select a reason", driverLate: "", driverMisbehave: "", dontWant: "", aftbooking: "afterbooking",
      Can_t_find_your_reason_Type_below: "", yes: "Yes", no: "No", success: "success", appoint: "booking_appointment", bfrbooking: "beforebooking",
      bookingCancel: "Booking Cancelled!",
      // cancelCharges: "Booking cancelled, you will be charged for cancellation as the cancellation period is not with in the range.",
      cancelCharges: "Booking cancelled",
      noBookingsAtDay: "sorry no bookings are available at this day", validDateRange: "please select valid date range!!"
    }

  public Notifications =
    {
      Sorry_we_cannot_take_up_your_delivery_request_at_this_moment_all_our_drivers_are_busy_Please_try_again_after_sometime: ""
    }

  public book_now =
    {
      newJob: "Ride Booking", walk: "Walking", trans: "Transit", driving: "Driving", approxTime: "Approx Time", approxDist: "Approx Dist", approxFare: "Approx Fare",
      bookingDetails: "Booking Details", pickupAdd: "Pickup Address", pickLoc: "pickup location", destAdd: "Destination Address", pickDest: "pickup location",
      vehicleType: "Vehicle Type", scaniaTrailer: "", truck: "", van: "", bike: "", miniTruck: "", pickup: "", towing: "", car: "",
      ratecard: "Rate card", capacity: "Capacity", lbh: "L x B x H", minfare: "Min fare", afterKm: "", afterMin: "", kgs: "Kgs", m: "", km: "", min: "Min",
      receiverDetails: "Receiver Details", sameSender: "Same as sender", name: "Name", rcvname: "receivername", phoneNumber: "Phonenumber",
      shipmentDetails: "Shipment Details", loose: "Loose", qty: "Quantity", refImage: "Reference image", goodsType: "Goods Type",
      tires: "", motorCycles: "", mattress: "", autoParts: "", groceries: "", blood: "", furniture: "", legalDocs: "", dryCleaning: "",
      pallets: "", food: "", printedMaterial: "", appliances: "", buildingRubble: "", gardenRefuse: "", retailPurchase: "", emailRgd: "Email already registered.",
      docs: "", lipatBahay: "", steelRods: "", windmil: "", plates: "", handlers: "No. of Handlers needed", desc: "Description", numRgd: "Number already registered.",
      paidBy: "Paid by", self: "Self", receiver: "receiver", payMethod: "Payment Method", creditLine: "Credit Line", noCard: "No card selected",
      addCard: "Add Card", modifyCard: "Modify Card", add: "Add", directionReqFail: "Directions request failed due to ", validCsv: "Please upload a valid CSV file.",
      cust_uberfortruck_com_says: "", please_select_a_vehicle: "", bookingcnf: "Booking Confirmed!", thanksBooking: "Thanks for the booking ! We will get the best possible rider and send you the booking details shortly !",
      This_field_is_required: "", please_enter_valid_address: "", success: "success", detailsUpdated: "Details Updated!", thanksDetails: "Thanks for the Giving details !",
      notImage: "Not an image", resizedImage: "upload resized image", noResults: "No results found", geoFail: "Geocoder failed due to: ",
    }

  public add_card =
    {
      wallet: "ADD CARD", cardNo: "Card Number", cardHolder: "Card holder", expDate: "Expiration date", m: "MM", y: "YYYY", cvv: "CVV",
      submit: "Submit", selectCard: "Select card", newCard: "Add New card", exp: "Exp", ok: "Ok", expires: "Expires"
    }

  public book_later =
    {
      pickupDate: "Select date to pickup", dateTime: "", ok: "OK", Please_select_date_to_continue: "", am: "AM", pm: "PM"
    }

  public bookingComplete =
    {
      bookid: "B-id", bookingcompleted: "Booking Completed", bookDetails: "Details", pickAdd: "Pickup Address", dropAdd: "Drop Address",
      driverDetails: "Driver Details", rating: "Give your Rating", review: "Please click on stars to give review", giveReview: "Give your Review",
      comments: "Please enter your comments", others: "Others", submit: "Submit"
    }

  public invoice =
    {
      invoice: "Invoice", fare: "Your Fare", breakDown: "Fare Breakdown", base: "Base Fee", distFee: "Distance Fee", timeFee: "Time Fee",
      waitFee: "Waiting Fee", subTotal: "Sub Total", addCharges: "Additional Charges", minAdj: "Min Fare Adjustment", discount: "Discount",
      toll: "Toll", handling: "Handling Fee", total: "Total", vat: "Vat", fixFee: "Fix Fee", minFee: "Minimum Fee"
    }

  public tasks =
    {
      loadBookings: "Loading Bookings",
      back: "", allTasks: "All Loads", filterDate: "Filter with date", to: "to", exportTasks: "Export Tasks", refresh: "Refresh", filters: "Filters",
      allBookings: "All Bookings", unassigned: "unassigned", driverAcc: "Driver accepted", youRej: "You cancelled", driverRej: "Driver cancelled",
      driveronway: "Driver is on the way", driverArr: "Driver arrived", bookingStarted: "Booking started", driverReached: "Driver has reached to Drop Location",
      driverUnlockedLoad: "Driver has unloded the load", completed: "Completed", bookingExpired: "Booking expired", sure: "Are you sure",
      aboutToCancel: "You're about to cancel this Ride", cancel: "cancel", close: "Close", orderId: "Order ID", rcvName: "Receiver Name",
      desc: "Description", pickupTime: "Pickup Time", dropTime: "Drop Time", pickupAdd: "Pickup Address", dropAdd: "Drop Address",
      vehicleType: "Vehicle Type", driverName: "Driver Name", driverPhone: "Driver Phone", taskStatus: "Task Status", actions: "Actions",
      loadMore: "LOAD MORE", teama: "Team A", teamb: "Team B", teamc: "Team C", download: "Download your task data in a CSV file", todayTask: "Today Tasks",
      custSel: "Custom selection", startDate: "Start Date", endDate: "End Date", reason: "Select your reason to cancel a Ride", cancelJob: "Cancel Ride"
    }
  public my_account =
    {
      accInfo: "Profile", profile: "PROFILE", fName: "First Name", phone: "Phone", email: "Email", changepwd: "Change Password",
      changeProfile: "Change Profile", name: "Name", update: "Update", changePhone: "Change your phone number", verifyPhone: "Enter your phone number to get verification code",
      phonenum: "Phone number", submit: "Get Verification Code", send: "Submit", resend: "Resend", curpwd: "Enter your current password", newpwd: "Enter your new password", reenter: "Confirm your new password",
      detailsUpdated: "Details Updated!", profUpSucc: "your profile has been successfully updated.", success: "success", numExist: "Number already registered.",
      resizedImage: "upload resized image", passContent: 'Password is updated',
      enterValidNum: "Please enter valid number",
      verifyCode: "Please enter the 4 digit Verification Code sent to"
    }

  public wallet =
    {
      EBBA: "",
      curCredit: "CURRENT CREDIT", softLimit: "Soft limit", hardLimit: "Hard limit", payCard: "Pay using card", addCardToPay: "Please add a card to make payment",
      addCard: "ADD CARD", delCard: "Delete Card", delcnf: "Are you sure you want to Delete this card", payamt: "Pay amount",
      enteramt: "Please enter the amount to continue", selectCard: "Please select a card to continue", cnf: "CONFIRM AND PAY",
      CreditIsMoney: "Credit is the money due to the app for past bookings", softLimitMax: "Soft Limit: The balance is closed to lowest allowed wallet limit",
      hardLimitMax: "Hard Limit: Lowest wallet limit and wallet cannot be used for bookings", yes: "Yes", no: "No", rechargecnf: "Are you sure you want to recharge your wallet with",
      all: "ALL", debit: "DEBIT", credit: "CREDIT", noTransAvail: "No transactions available", loadMore: "Load more", noTrans: "Sorry no more transactions",
      addNewCard: "Add new card", cardHolderName: "", expiration: "Expiration", mm: "MM", yyyy: "YYYY", flipCard: "Flip Card", cvv: "CVV / Security Code",
      cardValid: "Please enter valid card number", monthValid: "Please enter valid month", yearValid: "Please enter valid Year", entercvv: "Please enter cvv / security code",
      transId: "Trans ID", bookingId: "Booking ID", trip: "", na: "", recharge: "", noBookings: "Sorry no more bookings"
    }

  constructor() { }

}
